import { gql } from '@apollo/client';

import MESSAGE_FRAGMENT from '../fragments/message';

// export const MESSAGE_RECEIVED_SUB = gql`
//   subscription messageReceived($id: String!) {
//     messageReceived(id: $id) {
//       message
//       id
//       from {
//         id
//         firstName
//         lastName
//         avatar {
//           thumbnailPipeFrom
//         }
//       }
//       to {
//         id
//         firstName
//         lastName
//       }
//     }
//   }
// `;

// export const MESSAGE_SENT_SUB = gql`
//   subscription subMessages($id: String!) {
//     subMessages(id: $id) {
//       message
//       id
//       from {
//         id
//         firstName
//         lastName
//         avatar {
//           thumbnailPipeFrom
//         }
//       }
//       to {
//         id
//         firstName
//         lastName
//       }
//     }
//   }
// `;

export const NEW_MESSAGE_SUB = gql`
  ${MESSAGE_FRAGMENT}
  subscription subMessages($id: String!) {
    subMessages(id: $id) {
      ...MessageFragment
      chatRoom {
        id
      }
    }
  }
`;
